<template>
  <v-progress-linear
    indeterminate
    rounded
    :color="mainColor"
    :active="loading"
  ></v-progress-linear>
</template>

<script>
/**
 * @vue-prop {Boolean} loading - gives loading status
 * @vue-data {String} mainColor - returns the main color
 */
export default {
  name: "custom-progressbar",
  props: {
    loading: Boolean,
  },
  data() {
    return {
      mainColor: "",
    };
  },
  created() {
    this.mainColor = this.$vuetify.theme.themes.light.primary;
  },
};
</script>